import * as React from 'react'
import { CircularButton } from './CircularButton'
import Add from '@amzn/dvui/dist/Icons/Add'
import WatchlistOn from '@amzn/dvui/dist/Icons/WatchlistOn'
import { WatchlistAction, APIClient, serializeFormdata, WatchlistToggleOutput, ItemPrerolls } from '@utils'
import { fireDraperTrackingEvent } from '../../../../../../DVWebNodeDraperPlayer/utils/metrics'

export interface IntermissionHeroWatchlistActionProps {
  watchlistAction: WatchlistAction
  prerolls: ItemPrerolls
  updateWatchlistAction?: (newWatchlistAction: WatchlistAction) => void
}

export const WatchlistButton = (props: IntermissionHeroWatchlistActionProps) => {
  const onClick = (event: React.MouseEvent) => {
    if (!props.watchlistAction.ajaxEnabled) {
      return
    }
    event.preventDefault()
    const query = props.watchlistAction.endpoint && props.watchlistAction.endpoint.query
    const partialURL = props.watchlistAction.endpoint && props.watchlistAction.endpoint.partialURL
    const watchlistParams = serializeFormdata(query)
    const api = new APIClient
    api.call(partialURL, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-requested-with': 'XMLHttpRequest' // must be there for WPS not to do the redirect
      },
      body: watchlistParams
    }).then((json: WatchlistToggleOutput) => {
      const newAction = json.watchlistAction
      if (props.watchlistAction.tag !== newAction.tag && newAction.tag === 'Remove' && props.prerolls) {
        fireDraperTrackingEvent(props.prerolls, 'addToWatchlist')
      }
      props.updateWatchlistAction && props.updateWatchlistAction(newAction)
    })
  }

  return (
    <CircularButton
      onClick={onClick}
      icon={props.watchlistAction.tag === 'Add' ? <Add /> : <WatchlistOn />}
    />
  )
}